import React, { useState } from "react";
import { BsGridFill } from "react-icons/bs";
import { ImList } from "react-icons/im";
import { GoTriangleDown } from "react-icons/go";

/**
 * SEO-Optimized Product Banner Component
 * Provides product view toggle (grid/list), sorting, and pagination controls.
 * Enhances user experience and helps search engines understand content structure.
 */
const ProductBanner = ({ itemsPerPageFromBanner }) => {
  const [isGridView, setIsGridView] = useState(true);
  const [sortOption, setSortOption] = useState("Best Sellers");

  const handleViewToggle = (view) => {
    setIsGridView(view === "grid");
  };

  const handleItemsPerPage = (e) => {
    itemsPerPageFromBanner(+e.target.value);
  };

  const handleSortChange = (e) => {
    setSortOption(e.target.value);
    // Add additional logic if sorting affects displayed products
  };

  return (
    <section
      className="w-full flex flex-col md:flex-row md:items-center justify-between mb-6"
      aria-label="Product Controls Section"
    >
      {/* View Toggle Controls */}
      <div className="flex items-center gap-4">
        <button
          onClick={() => handleViewToggle("grid")}
          className={`w-8 h-8 text-lg flex items-center justify-center cursor-pointer rounded ${
            isGridView
              ? "bg-primeColor text-white"
              : "border-[1px] border-gray-300 text-[#737373]"
          }`}
          aria-label="Grid View"
        >
          <BsGridFill />
        </button>
        <button
          onClick={() => handleViewToggle("list")}
          className={`w-8 h-8 text-base flex items-center justify-center cursor-pointer rounded ${
            !isGridView
              ? "bg-primeColor text-white"
              : "border-[1px] border-gray-300 text-[#737373]"
          }`}
          aria-label="List View"
        >
          <ImList />
        </button>
      </div>

      {/* Sorting and Items Per Page */}
      <div className="flex items-center gap-4 md:gap-6 mt-4 md:mt-0">
        {/* Sort By */}
        <div className="flex items-center gap-2 text-base text-[#767676] relative">
          <label htmlFor="sortProducts" className="block font-semibold">
            Sort by:
          </label>
          <select
            id="sortProducts"
            value={sortOption}
            onChange={handleSortChange}
            className="w-32 md:w-52 border-[1px] border-gray-200 py-1 px-4 cursor-pointer text-primeColor text-base appearance-none focus:outline-none focus:border-primeColor"
          >
            <option value="Best Sellers">Best Sellers</option>
            <option value="New Arrival">New Arrival</option>
            <option value="Featured">Featured</option>
            <option value="Final Offer">Final Offer</option>
          </select>
          <span className="absolute text-sm right-2 md:right-4 top-2.5">
            <GoTriangleDown />
          </span>
        </div>

        {/* Items Per Page */}
        <div className="flex items-center gap-2 text-[#767676] relative">
          <label htmlFor="itemsPerPage" className="block font-semibold">
            Show:
          </label>
          <select
            id="itemsPerPage"
            onChange={handleItemsPerPage}
            className="w-16 md:w-20 border-[1px] border-gray-200 py-1 px-4 cursor-pointer text-primeColor text-base appearance-none focus:outline-none focus:border-primeColor"
          >
            <option value="12">12</option>
            <option value="24">24</option>
            <option value="36">36</option>
            <option value="48">48</option>
          </select>
          <span className="absolute text-sm right-3 top-2.5">
            <GoTriangleDown />
          </span>
        </div>
      </div>
    </section>
  );
};

export default ProductBanner;
